module.exports = __webpack_public_path__ + "coming-soon.6e22d8b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/coming-soon.png
// module id = 1725
// module chunks = 0